<template>
	<div class="detailbox">
		<div class="innnerBox">
			<el-row>
				<el-col :span="8" style="padding-right: 10px">
					<div class="leftbox">
						<div class="huititle"><img class="title1" src="/static/qmsj/img/hui/huixiut1.png" alt=""> 会员详细信息</div>
						<div class="touxiangbox">
							<img :src="base642" alt="">
							<div class="uploadBtn" @click="dialogVisible = true" style="cursor: pointer">上传照片</div>
						</div>
						<div class="btnbox">
							<div class="prBtn" v-if="vip==1" @click="shangkejl=true">计次记录</div>
							<div class="prBtn" v-if="vip==1" @click="xiuz=true">手动计次</div>
							<!--<div class="prBtn" v-if="vip==1" @click="get_convert">兑换商品</div>-->
						</div>

            <form style="font-size: 14px" method="post" id="tji">
              <input type="hidden" v-model="token" name="token">
              <input type="hidden" v-model="uid" name="user_id">
              <table style="width: 100%;text-align: left">
                <tr>
                  <td style="width: 20%">姓名：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.baobao_name}}</span>
                    <input v-if="xiu==1" v-model="basemeg.baobao_name" type="text" name="baobao_name" class="selectstyle">
                  </td>
                  <td style="width: 20%">别名：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.baobao_name2}}</span>
                    <input name="baobao_name2" v-if="xiu==1" v-model="basemeg.baobao_name2" type="text" placeholder="姓名" class="selectstyle">
                  </td>
                </tr>
                <tr>
                  <td>性别：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.baobao_sex}}</span>
                    <span v-if="xiu==1">
                      <template>
                        <el-radio v-model="basemeg.baobao_sex" name="baobao_sex" style="margin-right: 5px;" label="男">男</el-radio>
                        <el-radio v-model="basemeg.baobao_sex" name="baobao_sex" label="女">女</el-radio>
                      </template>
								    </span>
                  </td>
                  <td>出生日期：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.baobao_birthday}}</span>
                    <el-date-picker v-if="xiu==1"
                                    style="width: 100%"
                                    name="baobao_birthday"
                                    size="mini"
                                    value-format="yyyy-MM-dd"
                                    v-model="basemeg.baobao_birthday"
                                    type="date"
                                    placeholder="选择日期"
                                    format="yyyy-MM-dd">
                    </el-date-picker>
                  </td>
                </tr>
                <tr v-if="basemeg.name1">
                  <td>父亲：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.name1}}</span>
                    <input v-if="xiu==1" type="text" v-model="basemeg.name1" name="name[]" class="selectstyle">
                    <input v-if="xiu==1" type="hidden" value="1" name="guanxi[]">
                  </td>
                  <td>联系电话：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.phone1}}</span>
                    <input v-if="xiu==1" v-model="basemeg.phone1" name="phone[]" type="text" placeholder="电话" class="selectstyle">
                  </td>
                </tr>
                <tr v-if="basemeg.name2">
                  <td>母亲：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.name2}}</span>
                    <input v-if="xiu==1" type="text" v-model="basemeg.name2" name="name[]" class="selectstyle">
                    <input v-if="xiu==1" type="hidden" value="2" name="guanxi[]">
                  </td>
                  <td>联系电话：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.phone2}}</span>
                    <input v-if="xiu==1" v-model="basemeg.phone2" name="phone[]" type="text" placeholder="电话" class="selectstyle">
                  </td>
                </tr>
                <tr v-if="basemeg.name3">
                  <td>爷爷：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.name3}}</span>
                    <input v-if="xiu==1" type="text" v-model="basemeg.name3" name="name[]" class="selectstyle">
                    <input v-if="xiu==1" type="hidden" value="3" name="guanxi[]">
                  </td>
                  <td>联系电话：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.phone3}}</span>
                    <input v-if="xiu==1" v-model="basemeg.phone3" name="phone[]" type="text" placeholder="电话" class="selectstyle">
                  </td>
                </tr>
                <tr v-if="basemeg.name4">
                  <td>奶奶：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.name4}}</span>
                    <input v-if="xiu==1" type="text" v-model="basemeg.name4" name="name[]" class="selectstyle">
                    <input v-if="xiu==1" type="hidden" value="4" name="guanxi[]">
                  </td>
                  <td>联系电话：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.phone4}}</span>
                    <input v-if="xiu==1" v-model="basemeg.phone4" name="phone[]" type="text" placeholder="电话" class="selectstyle">
                  </td>
                </tr>
                <tr v-if="basemeg.name5">
                  <td>姥爷：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.name5}}</span>
                    <input v-if="xiu==1" type="text" v-model="basemeg.name5" name="name[]" class="selectstyle">
                    <input v-if="xiu==1" type="hidden" value="5" name="guanxi[]">
                  </td>
                  <td>联系电话：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.phone5}}</span>
                    <input v-if="xiu==1" v-model="basemeg.phone5" name="phone[]" type="text" placeholder="电话" class="selectstyle">
                  </td>
                </tr>
                <tr v-if="basemeg.name6">
                  <td>姥姥：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.name6}}</span>
                    <input v-if="xiu==1" type="text" v-model="basemeg.name6" name="name[]" class="selectstyle">
                    <input v-if="xiu==1" type="hidden" value="6" name="guanxi[]">
                  </td>
                  <td>联系电话：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.phone6}}</span>
                    <input v-if="xiu==1" v-model="basemeg.phone6" name="phone[]" type="text" placeholder="电话" class="selectstyle">
                  </td>
                </tr>
                <tr v-if="xiu==1" >
                  <td colspan="4">
                    <div style="padding-bottom: 5px;">
                      点击添加家属：<img src="/static/qmsj/img/+.png" style="width: 18px;vertical-align: middle" @click="jia" alt="">
                      <img src="/static/qmsj/img/tixing.png" style="width: 18px;vertical-align: middle" @click="jian" alt="">
                    </div>
                  </td>
                </tr>
                <tr v-for="i in shu" v-if="xiu==1">
                  <td colspan="4">
                    <select name="guanxi[]" class="selectstyle" style="width: 20%;margin-left: 1%">
                      <option value="1">爸爸</option>
                      <option value="2">妈妈</option>
                      <option value="3">爷爷</option>
                      <option value="4">奶奶</option>
                      <option value="5">姥爷</option>
                      <option value="6">姥姥</option>
                    </select>
                    <input type="text" placeholder="姓名" name="name[]" class="selectstyle" style="width: 20%;margin-left: 1%">
                    联系电话：<input type="text" name="phone[]" class="selectstyle" style="width: 30%;margin-left: 1%">
                  </td>
                </tr>
                <tr>
                  <td>会员卡号：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.kahao}}</span>
                    <input v-if="xiu==1" name="kahao" v-model="basemeg.kahao" type="text" class="selectstyle">
                  </td>
                </tr>
                <tr>
                  <td>来源：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.laiyuan}}</span>
                    <select name="laiyuan" v-if="xiu==1" v-model="basemeg.laiyuan" class="selectstyle">
                      <option v-for="item in option44" :value="item.label">{{item.label}}</option>
                    </select>
                  </td>
                  <td>采单人：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.cdr}}</span>
                    <select name="cdr" v-if="xiu==1" v-model="basemeg.cdr_id" class="selectstyle">
                      <option v-for="gu in staff_list" :value="gu.user_id">{{gu.username}}</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>地址：</td>
                  <td colspan="3">
                    <span v-if="xiu==0">{{basemeg.site}}</span>
                    <select name="sheng" v-if="xiu==1" v-model="basemeg.sheng" @change="shengxuan" class="selectstyle" style="width: auto;">
                      <option v-for="shitem in shiqu" :value="shitem.REGION_ID">{{shitem.REGION_NAME}}
                      </option>
                    </select>
                    <select name="coun" v-if="xiu==1" v-model="basemeg.shi" @change="shixuan" class="selectstyle" style="width: auto;">
                      <option v-for="shitem2 in shiqu2" :value="shitem2.REGION_ID">
                        {{shitem2.REGION_NAME}}
                      </option>
                    </select>
                    <select name="qu" v-if="xiu==1" v-model="basemeg.qu" class="selectstyle" style="width: auto;">
                      <option v-for="shitem3 in shiqu3" :value="shitem3.REGION_ID">
                        {{shitem3.REGION_NAME}}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr v-if="xiu==1">
                  <td>详细地址：</td>
                  <td colspan="3">
                    <div style="padding-top: 8px">
									    <textarea name="site" v-model="basemeg.dz" style="width: 100%;border-color: #dcdfe6;color: #000;box-sizing: border-box;padding: 5px" cols="10" rows="3"></textarea>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>备注：</td>
                  <td colspan="3">
                    <span v-if="xiu==0">{{basemeg.beizhu}}</span>
                    <input name="beizhu" v-if="xiu==1" type="text" v-model="basemeg.beizhu" class="selectstyle" style="width: 100%;padding-left: 10px">
                  </td>
                </tr>
                <tr>
                  <td colspan="4" style="text-align: center;border-bottom: 1px solid black;border-top: 1px solid black;">监护人信息</td>
                </tr>
                <tr>
                  <td>监护人：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.consignee_name}}</span>
                    <input name="consignee_name" v-if="xiu==1" type="text" v-model="basemeg.consignee_name" class="selectstyle">
                  </td>
                  <td>手机号码：</td>
                  <td>
                    <span v-if="xiu==0">{{basemeg.consignee_phone}}</span>
                    <input name="consignee_phone" v-if="xiu==1" type="text" v-model="basemeg.consignee_phone" class="selectstyle">
                  </td>
                </tr>
                <tr>
                  <td>身份证号：</td>
                  <td colspan="3">
                    <span v-if="xiu==0">{{basemeg.p_id_number}}</span>
                    <input name="p_id_number" v-if="xiu==1" type="text" v-model="basemeg.p_id_number" class="selectstyle">
                  </td>
                </tr>
              </table>
            </form>

						<div>
							<div style="height: 50px;display:flex;justify-content:center;" v-if="xiu==0">
								<div class="prBtn" style="margin: 10px 6px 0;display: inline-block;" @click="xiu=1">修改</div>
							</div>

							<div style="height: 60px;display: flex;display: -webkit-flex;justify-content: space-between" v-if="xiu==1">
								<div class="prBtn" style="margin: 10px auto 0;display: block" @click="xiumsg">确认修改</div>
								<div class="prBtn" style="margin: 10px auto 0;display: block" @click="xiu = 0">取消修改</div>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :span="16" class="rightBox">
<!--合约记录-->
					<div style="position: relative">
						<div class="leftbox">
							<div class="huititle" style="margin-bottom: 0">
								<img class="title1" src="/static/qmsj/img/hui/libao.png" alt="">
								&nbsp; 合约记录
							</div>
							<div style="text-align: center;" v-if="hylist==''">暂无合约记录</div>
							<div class="shopBox" v-for="(hy,index) in hylist" style="border:1px dashed #A3A3A3;">
								<div class="prBtn" style="float: right" @click="tuiqian(hy.jl_id)">退签合约</div>
								<div class="prBtn" style="float: right;margin-right: 15px;" v-if="hy.vip== 1" @click="jumpprint(hy.jl_id,hy.z_jlid, hy.system_flag)">打印合同</div>
								<span style="float:right;margin-right:30px;font-size:14px;padding-top:6px;">消费次数:{{hy.class_cut}}</span>
								<div style="clear:both"></div>
								<div style="padding:10px 0 0 22px;margin-top: 5px;background-color: #f1f1f1;border-radius: 5px;">
									<el-row>
										<el-col :span="6">
                      <p class="hetonglist">商品名称：{{hy.s_name}}</p>
											<p class="hetonglist">合同编号：{{hy.hetong}}</p>
                      <p class="hetonglist">裸视力：R-{{hy.right}} L-{{hy.left}}</p>
										</el-col>
										<el-col :span="6">
											<p class="hetonglist">实收金额：{{hy.shishou}}/元</p>
                      <p class="hetonglist">销售价：{{hy.receivable}}</p>
                      <p class="hetonglist">有效期：{{hy.expiration_date}}个月</p>
										</el-col>
										<el-col :span="6">
                      <p class="hetonglist">商品次数：{{hy.k_shu}}/次</p>
                      <p class="hetonglist">次单价：{{hy.avg_price}}</p>
                      <p class="hetonglist">剩余次数：{{hy.y_keshi}}</p>
										</el-col>
                    <el-col :span="6">
                      <p class="hetonglist">签约时间：{{hy.time}}</p>
                      <p class="hetonglist">到期时间：{{hy.e_time}}</p>
                    </el-col>
									</el-row>
								</div>
							</div>
						</div>
					</div>
<!--活动记录-->
					<div style="position: relative">
						<div class="leftbox">
							<div class="huititle" style="margin-bottom: 0"><img class="title1" src="/static/qmsj/img/hui/huodjil.png" alt="">
								&nbsp; 活动记录
							</div>

							<p style="text-align: center;height: 30px;line-height: 30px" v-if="activitystatus">暂无数据</p>
							<div class="shopBox" v-if="!activitystatus">
								<div class="xiala2">

									<el-collapse accordion>
										<el-collapse-item>
											<template slot="title"  v-if="activity[0]">
												<el-row style="width: 100%">
													<el-col :span="6">
														<p class="hetonglist">{{activity[0].title}}</p>
													</el-col>
													<el-col :span="6">
														<p class="hetonglist">负责人：{{activity[0].teacher}}</p>
													</el-col>
													<el-col :span="6">
														<p class="hetonglist">{{activity[0].start_time}}</p>
													</el-col>
													<!--<el-col :span="5">-->
														<!--<p class="hetonglist">耗课：{{activity[0].xiaohao}}节</p>-->
													<!--</el-col>-->
												</el-row>
											</template>
											<div v-if="activity.length>1">
												<el-row v-for="(act, index) in activity.slice(1)" :key="index" style="width: 100%">
													<el-col :span="6">
														<p class="hetonglist">{{act.title}}</p>
													</el-col>
													<el-col :span="6">
														<p class="hetonglist">负责人：{{act.teacher}}</p>
													</el-col>
													<el-col :span="6">
														<p class="hetonglist">{{act.start_time}}</p>
													</el-col>
													<!--<el-col :span="6">-->
														<!--<p class="hetonglist">耗课：{{act.xiaohao}}节</p>-->
													<!--</el-col>-->
												</el-row>
											</div>
										</el-collapse-item>
									</el-collapse>
								</div>

							</div>
						</div>

					</div>

				</el-col>
			</el-row>


		</div>

		<!-- 修改合约 -->
		<el-dialog class="tanchuang" :visible.sync="dialogVisible4" width="670px" :close-on-click-modal="false">
			<span slot="title" class="dialog-footer">修改合约</span>
			<div style="overflow-y:scroll;overflow-y: auto; max-height:450px;">
				<div v-for="(xh,index) in xhBaseData" style="padding-top: 10px;">
					<el-row>
						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">合约编号</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" style="width: 100%" :disabled="true" v-model="xh.hetong" placeholder="请输入内容"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">课时包</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-select name="s_id" v-model="xh.s_id" @change="save_price(xh.s_id,index)" size="small" placeholder="请选择">
											<el-option v-for="(item,indexr) in keshibao" :key="item.s_id" :label="item.s_name" :value="item.s_id">
											</el-option>
										</el-select>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">收据编号</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" v-model="xh.dindan" style="width: 100%" placeholder="请输入内容"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">课时节数</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" v-model="xh.k_shu" :disabled="true" style="width: 100%"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">销售价</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" :disabled="true" v-model="xh.price" style="width: 100%" placeholder="请输入内容"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">赠课时</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" v-model="xh.zeng_ke" style="width: 100%" placeholder="请输入内容"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">销售人</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-select name="guwen" v-model="xh.guwen" size="small" placeholder="请选择">
											<el-option v-for="item in staff_list" :key="item.user_id" :label="item.username" :value="item.user_id"></el-option>
										</el-select>

									</el-col>
								</el-row>
							</div>
						</el-col>
						<br />
						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">合约起止时间</div>
								<div style="width: 200px" class="qizhishij">
									<el-date-picker v-model="xh.create_time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="mini"></el-date-picker>
									<el-date-picker v-model="xh.e_time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="mini"></el-date-picker>
								</div>
							</div>
						</el-col>
						<el-col :span="24">
							<div class="prolist">
								<div class="prolistname">备注</div>

								<textarea name="" cols="30" style="width: 493px;height: 80px;resize: none" class="el-input__inner" v-model="xh.bz"></textarea>

							</div>
						</el-col>
					</el-row>
				</div>
				<div>
					<div class="shengqx" style="margin-top: 15px">
						<el-button size="small" @click="dialogVisible4 = false">取消</el-button>
						<el-button size="small" type="success" @click="shenxiu">申请修改</el-button>
					</div>

					<p style="padding-left:20px;padding-right:20px;text-indent:2em;text-align:left;font-size:14px;padding-top:10px;color: #666">
						注：合约内任何信息修改，需中心总监或投资人在微信端审批通过后，才能生效。申请审批记录和审批结果请在申请人的个人中心内查看。
					</p>
				</div>


			</div>

		</el-dialog>
		<!-- 修改合约end -->
		<!-- 退签合约 -->
		<el-dialog class="tanchuang" :visible.sync="dialogVisible5" width="660px" :close-on-click-modal="false">
			<span slot="title" class="dialog-footer">退签合约</span>
			<div style="overflow-y:scroll;overflow-y: auto; max-height:450px;">
				<div v-for="(t,index) in tui_list">
					<el-row>
						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">合约编号</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" style="width: 100%" :disabled="true" v-model="t.hetong" placeholder="请输入内容"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">商品服务</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" v-model="t.s_name" :disabled="true" style="width: 100%"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>
						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">总次数</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" v-model="t.k_shu" :disabled="true" style="width: 100%"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>
            <el-col :span="12">
              <div class="prolist">
                <div class="prolistname">剩余次数</div>
                <el-row style="width: 185px">
                  <el-col :span="24">
                    <el-input size="small" v-model="t.y_keshi" :disabled="true" style="width: 100%"></el-input>
                  </el-col>
                </el-row>
              </div>
            </el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">合约起止时间</div>
								<div style="width: 200px" class="qizhishij">
									<p style="font-size: 12px;">{{t.create_time}}-{{t.e_time}}</p>
								</div>

							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">实收金额</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" disabled v-model="t.shishou" style="width: 100%"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">单价</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" disabled v-model="t.avg_price" style="width: 100%"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="prolist">
								<div class="prolistname">销售人</div>
								<el-row style="width: 185px">
									<el-col :span="24">
										<el-input size="small" disabled v-model="t.username" style="width: 100%"></el-input>
									</el-col>
								</el-row>
							</div>
						</el-col>

						<el-col :span="24">
							<div class="prolist">
								<div class="prolistname">备注</div>
								<textarea name="" cols="30" disabled style="width: 493px;height: 80px;resize: none" class="el-input__inner"
								 v-model="t.bz"></textarea>

							</div>
						</el-col>
            <el-col :span="24">
              <div class="shengqx" style="margin-top: 15px">
                <el-button size="small" @click="dialogVisible5=false">取消</el-button>
                <el-button size="small" type="success" @click="tui_del(t.jl_id)">确认退签</el-button>
              </div>
              <p style="padding-left:20px;padding-right:20px;text-indent:2em;text-align:left;font-size:14px;padding-top:10px;color: #666"></p>
            </el-col>
					</el-row>
				</div>

			</div>

		</el-dialog>
		<!-- 退签合约end -->


		<el-dialog class="tanchuang" :visible.sync="dialogVisible" width="280px">
			<span slot="title" class="dialog-footer">选择头像</span>
			<div style="width: 200px;margin:0 auto;">
				<croppa v-model="croppa" placeholder="点击上传，或拖拽上传" :placeholder-font-size="14"></croppa>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="success" @click="upload">确 定</el-button>
			</span>
		</el-dialog>



		<el-dialog class="tanchuang" :visible.sync="shangkejl" width="660px" :close-on-click-modal="false">
			<span slot="title" class="dialog-footer">消费记录</span>
			<div>
				<el-row>
					<table class="table table-bordered table-striped table-hover" v-loading="loading2">
						<thead>
							<tr>
								<th>商品名称</th>
								<th>计次时间</th>
								<th>计次数量</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(li,index) in skjl" :key="index">
								<td>{{li.kc_name}}</td>
								<td>{{li.create_time}}</td>
								<td>{{li.xiaohao}}次</td>
							</tr>
						</tbody>
					</table>

					<div class="table-bottom">
						<div>
							<el-pagination @current-change="fanye" :page-size="skjlpageone" background :total="skjlnum" :current-page="curpage"
							 layout="prev, pager, next">
							</el-pagination>
						</div>
					</div>

				</el-row>
			</div>
			<!--<div>-->

			<!--</div>-->
			<!--<span slot="footer" class="dialog-footer">-->
			<!--<div   @click="xiugai" class="xzyg" style="margin:0 auto">申请修改</div>-->

			<!--</span>-->
		</el-dialog>

		<!--修正课时弹窗start-->
		<el-dialog class="tanchuang" :visible.sync="xiuz" width="370px" center>
			<span slot="title" class="dialog-footer" style="font-size: 15px;">手动计次</span>
			<div>
				<el-row style="margin: 10px 0px;">
					<el-col :span="8">
						<div style="line-height: 32px">合约项目：</div>
					</el-col>
					<el-col :span="15">
						<select class="select3" v-model="kk_jlid" style="height: 28px;padding-left:10px;">
							<option v-for="item in option2" :value="item.jl_id">
								{{item.hetong}}--{{item.s_name}}
							</option>
						</select>
					</el-col>
				</el-row>
				<el-row style="margin: 10px 0px;">
					<el-col :span="8">
						<div style="line-height: 32px">扣除次数：</div>
					</el-col>
					<el-col :span="15">
						<el-input-number v-model="kouke" size="small" controls-position="right" :min="0"></el-input-number>
					</el-col>
				</el-row>
        <el-row style="margin: 10px 0px;">
          <el-col :span="8">
            <div style="line-height: 32px">计次日期：</div>
          </el-col>
          <el-col :span="15">
            <el-date-picker style="width: 100%"
                            size="mini"
                            value-format="yyyy-MM-dd"
                            v-model="kk_date"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy-MM-dd">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row style="margin: 10px 0px;">
          <el-col :span="8">
            <div style="line-height: 32px">技师：</div>
          </el-col>
          <el-col :span="15">
            <select class="select3" v-model="staff_id" style="height: 28px;padding-left:10px;">
              <option v-for="item_staff in staff_list" :value="item_staff.user_id">
                {{item_staff.username}}
              </option>
            </select>
          </el-col>
        </el-row>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="xiuz = false" size="mini">取 消</el-button>
				<el-button type="success" size="mini" @click="shanke">确 定</el-button>
			</span>
		</el-dialog>
		<!--修正课时弹窗end-->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				vip: '',
				xiu: "0",
				xiuz: false,
				croppa: {},
				uid: '',
				token: '',
				shu: 0,
				dialogVisible: false,
				dialogVisibled: false,
				shangkejl: false,
				value10: '',
				keshibao: [],
				xsr: '',
				xsrbox: [],
				keshib: '',
				dialogVisible4: false,
				dialogVisible5: false,
				base642: '',
				basemeg: '',
				loading2: false,
				skjl: '',
				skjlnum: "",
				skjlpageone: '',
				guoqi: "",
				curpage: 1,
				kouke: 0,
				guwen: '',
				shiqu: '',
				shiqu2: '',
				shiqu3: '',
				sheng: '',
				shi: '',
				qu: '',
				options: [],
				value8: '',
				activity: '',
				xkjl: '',
				huoqistatue: false,
				activitystatus: false,
				xkjlstatus: false,
				chengzs: false,
				chengz: '',
				lpdhs: false,
				lpdh: '',
				lpid: '',
				lpiod: '',
				zengpin: '',
				s_etime: '',
				jl_id: '',
				xhBaseData: '',
				qushisj: '',
				tui_list: '',
				tui_time: '',
				hylist: '', //合约数组
				z_jlid: '',
				nexus_c: '',
				option2: '',
				option44: '',
        kk_jlid: '',
        kk_date:'',
				centre_id: 0,
				xk_centre_id: 0,
				convert_dialogVisible: false, //兑换商品
				currentPage3: 1,
				search_val: '',
				select_id: '',
				goods_data: [],
				goods_type: [],
				page_data: '',
				showPublicContract: false,
				k_name: '',
				K_smallName: '',
				k_date: '',
				k_sex: '男',
				k_laiyuan: '市场',
				k_options: [],
        system_flag:'M',
        tuifei_k:false,
        jieye_k:false,
        xiugai_k:false,
        zhy_k:false,
        tf_jl_id:'',
        jy_jl_id:'',
        zhy_jl_id:'',
        tf_logs:[],
        jy_logs:[],
        zhy_logs:[],
        tf_list:[],
        xg_list:[],
        jy_list:[],
        zhy_list:[],
        staff_list:'',
        staff_id:'',
        zhy_note:'',
        all_calc_return_price:0,
        return_price:'',
			};
		},
		methods: {

			//选择课程包
			save_price(i, index) {
				let that = this
				$.ajax({
					url: process.env.apiUrl + 'saas/user/get_ksb_yhq_shu',
					type: 'post',
					data: {
						token: that.token,
						s_id: i
					},
					success: function(data) {
						if (data.status == 1) {
							that.xhBaseData[index].price = data.data.price
							that.xhBaseData[index].k_shu = data.data.k_shu
						} else {
							that.xhBaseData.price = 0
							that.xhBaseData.k_shu = 0
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			jumpprint(id, zid, type) {
				let name = 'show_con' // M 为托育  其他为 早教
				let routeUrl  = this.$router.resolve({
					name: name,
					query: {
						id: id
					}
				})
				window.open(routeUrl.href, '_blank')
			},
			shenxiu: function() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/User/xiuhy",
					data: {
						token: self.token,
						arr: self.xhBaseData,
					},

					success: function(data) {
						if (data.status == 2) {
							self.$message.warning(data.msg);
							self.dialogVisible4 = false;
						} else if (data == 1) {
							self.$message.success(`您的审核已提交`);
							self.dialogVisible4 = false;


						} else {
							self.$message.error(`申请修改失败！`);
						}

					},
					error: function() {
						self.$message.error(`申请修改请求失败！`);
					}
				});
			},
			xiugait: function(jl_id) {
				this.dialogVisible4 = true;
				this.jl_id = jl_id;
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/User/hyjl",
					data: {
						token: self.token,
						jl_id: self.jl_id,
					},

					success: function(data) {
						self.xhBaseData = data;
					},
					error: function() {
						self.$message.error(`修改合约默认信息加载失败！`);
					}
				});
			},
			tuiqian: function(jl_id) {
				this.dialogVisible5 = true;
				this.jl_id = jl_id;
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/tq/hetong",
					data: {
						token: self.token,
						user_id: self.uid,
						jl_id: self.jl_id,
					},
					success: function(data) {
						self.tui_list = data.data;
					},
					error: function() {
						self.$message.error(`合约默认信息加载失败！`);
					}
				});
			},
			tui_del: function(jl_id) {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/tq/tuiqian",
					data: {
						token: self.token,
						jl_id: jl_id,
					},
					success: function(data) {
						if (data.status == 1) {
							self.$message.warning(data.msg);
							self.dialogVisible5 = false;
							self.heyue_state()
						} else if (data.status == 2) {
							self.$message.error(data.msg);
							self.dialogVisible5 = false;
							self.heyue_state()
						}
					},
					error: function() {
						self.$message.error(`退签失败！`);
					}
				});

			},
			shengxuan: function() {
				this.basemeg.qu = ''
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/User/sheng",
					data: {
						token: self.token,
						user_id: self.uid,
						sheng: self.basemeg.sheng
					},
					success: function(data) {
						self.shiqu2 = data
					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
			shixuan: function() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/User/sheng",
					data: {
						token: self.token,
						user_id: self.uid,
						sheng: self.basemeg.shi
					},
					success: function(data) {
						self.shiqu3 = data
					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
			fanye: function(i) {
				let self = this;
				self.curpage = i;
				self.publictable();
			},
			publictable: function() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/User/skjl",
					data: {
						token: self.token,
						user_id: self.uid,
						p: self.curpage,
						username: self.value8
					},
					beforeSend: function(xhr) {
						self.loading2 = true
					},
					success: function(data) {
						self.loading2 = false;
						self.skjl = data.zong;
						self.skjlnum = Number(data.fen.num);
						self.skjlpageone = Number(data.fen.pageone);
					},
					error: function() {
						self.loading2 = false
						self.$message.error(`请求失败`);
					}
				});
			},

			jia: function() {
				if (this.shu < this.nexus_c) {
					this.shu++
				}
			},
			jian: function() {
				if (this.shu > 0) {
					this.shu--
				}
			},
			xiumsg: function() {
				let self = this;
				var art_form = new FormData($('#tji')[0]);
				$.ajax({
					"type": "post",
					"url": process.env.apiUrl + "saas/User/xiutj",
					contentType: false,
					processData: false,
					"dataType": "json",
					"data": art_form,
					success: function(data) {
						if (data.status == 3) {
							self.xiu = 0
							self.$message.success('修改成功！');
							self.get_data()
						} else {
							self.$message.error(`${data.msg}`);
						}
					}
				});
			},
			xiugai: function() {},
			upload() {
				if (!this.croppa.hasImage()) {
					alert('您没有选择图片')
					return false;
				}
				this.base64 = this.croppa.generateDataUrl();
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/User/tonx',
					data: {
						img: self.base64,
						user_id: self.uid,
						token: self.token
					},
					type: 'POST',
					dataType: 'json',
					success: function(data) {
						if (data == 1) {
							self.$message.success('上传成功');
							self.dialogVisible = false;
							self.base642 = self.base64
						} else {
							self.$message.error('上传失败，请检查您的网络');
						}
					}
				})
			},
			shanke: function() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/User/kouke",
					data: {
						token: self.token,
						user_id: self.uid,
						kouke: self.kouke,
						jl_id: self.kk_jlid,
            staff_id:self.staff_id,
						kk_date: self.kk_date,
					},
					success: function(res) {
						if (res.status == 1) {
							self.$message.success(`扣除成功！`);
							self.xiuz = false
              self.publictable()
						} else {
							self.$message.error(res.msg);
						}
					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
      //获取员工信息
      get_staff(){
        let that = this;
        $.ajax({
          url: process.env.apiUrl + "saas/user/allstaff",
          type: "post",
          data: {
            token: that.token
          },
          success: function (res) {
            that.staff_list = res.data;
          },
        });
      },
			// 合约数组
			heyue_state: function() {
				let self = this
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/user/contract",
					data: {
						token: self.token,
						user_id: self.uid
					},
					success: function(data) {
						if (data.status == 1) {
							self.hylist = data.data
						} else if (data.status == 2) {
							self.hylist = ""
						}
						self.centre_id = data.centre_id;
					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
      get_guoqi(){
          let self = this;
          $.ajax({
              type: 'POST',
              url: process.env.apiUrl + "saas/User/guoqi",
              data: {
                  token: self.token,
                  user_id: self.uid
              },
              success: function(data) {
                  if (data.status == '1004') {
                      self.huoqistatue = true
                  } else {
                      self.huoqistatue = false
                      self.guoqi = data
                  }
              },
              error: function() {
                  self.$message.error(`请求失败`);
              }
          });
      },
			get_data(){
				let self = this
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/User/huiyuanlieb",
					data: {
						token: self.token,
						user_id: self.uid
					},
					success: function(data) {
						self.basemeg = data;
						self.nexus_c = data.check;
						self.base642 = data.img;
						self.sheng = data.sheng
						self.shi = data.shi
						self.qu = data.qu

						//市区
						$.ajax({
							type: 'POST',
							url: process.env.apiUrl + "saas/User/city",
							data: {
								token: self.token,
								user_id: self.uid,
							},
							success: function(data) {
								self.shiqu = data
							},
							error: function() {
								self.$message.error(`请求失败`);
							}
						});

						$.ajax({
							type: 'POST',
							url: process.env.apiUrl + "saas/User/sheng",
							data: {
								token: self.token,
								user_id: self.uid,
								sheng: self.sheng
							},
							success: function(data) {
								self.shiqu2 = data
							},
							error: function() {
								self.$message.error(`请求失败`);
							}
						});

						$.ajax({
							type: 'POST',
							url: process.env.apiUrl + "saas/User/sheng",
							data: {
								token: self.token,
								user_id: self.uid,
								sheng: self.shi
							},
							success: function(data) {
								self.shiqu3 = data
							},
							error: function() {
								self.$message.error(`请求失败`);
							}
						});
					},
					error: function() {
						self.$message.error(`请求失败`);
					}
				});
			},
      get_hy_item(){
        let self = this;
        $.ajax({
          type: 'post',
          url: process.env.apiUrl + "saas/user/get_hy_item",
          dataType: 'json',
          data: {
            'token': self.token,
            'user_id':self.uid
          },
          success: function(res) {
            self.option2 = res.data;
          },
          error: function() {
            self.$message.error(`请求失败`);
          }
        });
      },
		},
		filters: {
			jieke: function(value) {
				if (value == 1) {
					return '未结课';
				} else if (value == 2) {
					return '已结课'
				} else {
					return '数据丢失';
				}
			},
			week: function(value) {
				if (value == 1) {
					return '周一';
				} else if (value == 2) {
					return '周二'
				} else if (value == 3) {
					return '周三'
				} else if (value == 4) {
					return '周四'
				} else if (value == 5) {
					return '周五'
				} else if (value == 6) {
					return '周六'
				} else if (value == 7) {
					return '周日'
				} else {
					return '无数据'
				}
			},
		},
		mounted: function() {
			let self = this;
			self.uid = this.$route.query.id;
			self.vip = this.$route.query.vip;
			self.token = self.$cookies.get('token');

      self.get_data()
      self.get_staff()
      self.publictable()
      // self.get_guoqi()

			$.ajax({
				type: 'POST',
				url: process.env.apiUrl + "saas/User/activity",
				data: {
					token: self.token,
					user_id: self.uid
				},
				success: function(data) {
					if (data.status == '1004') {
						self.activitystatus = true
					} else {
						self.activitystatus = false
						self.activity = data
					}
				},
				error: function() {
					self.$message.error(`请求失败`);
				}
			});


			$.ajax({
				type: 'POST',
				url: process.env.apiUrl + "saas/User/keshi",
				data: {
					token: self.token
				},
				success: function(data) {
					self.keshibao = data
				},
				error: function() {
					self.$message.error(`课时包内容加载失败！`);
				}
			});


			// 合约数组
      self.heyue_state()
			// 合约类型
			self.get_hy_item()
			// 来源下拉
			$.ajax({
				url: process.env.apiUrl + 'saas/index/get_source',
				type: 'post',
				data: {
					token: self.token
				},
				success: function(e) {
					self.option44 = e.data
				},
			})
		}
	}
</script>

<style scoped>
	em,
	i {
		font-style: normal;
	}


	/* 兑换商品 */
	.dia_header {
		padding: 12px 12px 12px 30px;
		background: #8CBB77;
		position: relative;
	}

	.dia_header .search_inp {
		height: 30px;
		margin-left: 10px;
		padding-left: 10px;
		outline: none;
		border: 1px solid gray;
		border-radius: 5px;
		margin-right: 5px;
	}

	.dia_header .search_sel {
		height: 30px;
		padding-right: 10px;
		padding-left: 5px;
		border-radius: 3px;
		vertical-align: middle;
		margin-top: -3px;
	}

	.dia_header .el_close {
		color: rgb(255, 255, 255);
		font-size: 24px;
		float: right;
		margin-right: 18px;
		margin-top: -2px;
		cursor: pointer;
	}

	.three-table {
		width: 100%;
	}

	.three-table th
	td {
		text-align: center;
		padding-top: 12px;
	}

	.three-table .input_num {
		width: 55px;
		text-align: center;
	}

	.detailbox {
		width: 100%;
		min-height: 100%;
		box-sizing: border-box;
		padding: 7px 9px;
	}

	.innnerBox {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		border-radius: 12px;
		background: #ededed;
		padding: 10px;
	}

	.table-bottom {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		display: -webkit-flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
	}

	.leftbox {
		background: #fff;
		padding: 14px 20px 0;
		border-radius: 12px;
		margin-bottom: 10px;
		padding-bottom: 15px;
	}
  #tji table tr{
    height: 28px;
  }
  #tji table tr td:nth-child(2n){
    width: 115px;
  }
  #tji table tr td:nth-child(2n-1){
    /*text-align: justify;*/
    /*text-justify:distribute-all-lines;*/
    /*text-align-last: justify;*/
    /*border:1px solid red;*/
    text-align: right;
    padding-right: 5px;
  }

	.title1 {
		width: 22px;
		vertical-align: middle;
	}

	.huititle {
		line-height: 26px;
		font-size: 18px;
		margin-bottom: 24px;
	}

	.touxiangbox {
		width: 200px;
		height: 200px;
		border-radius: 100px;
		background: #a3a3a3;
		overflow: hidden;
		margin: 0 auto 22px;
		position: relative;
	}

	.touxiangbox img {
		width: 100%;
		height: 100%;
	}

	.uploadBtn {
		width: 100%;
		height: 44px;
		background: rgba(0, 0, 0, 0.5);
		line-height: 44px;
		text-align: center;
		font-size: 14px;
		color: #fff;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.btnbox {
		display: flex;
		justify-content: space-between;
		margin-bottom: 22px;
	}

	.prBtn {
		width: 100px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		border-radius: 15px;
		background: #8CBB77;
		color: #fff;
		font-size: 14px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .3);
		cursor: pointer;
	}

	.messagebox {
		padding-left: 30px;
		font-size: 14px;
		position: relative;
	}

	.messagebox span {
		color: #999;
	}

	.meslist {
		margin-bottom: 8px;
	}

	.selectstyle {
		width: 102px;
		/*height: 20px;*/
		/*font-size: 12px;*/
		color: #000000;
		border: 1px solid grey;
		border-radius: 3px;
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.shopBox {
		padding: 19px 24px;
		margin-top: 5px;
		border-radius: 5px;
	}

	.shoplist {
		padding-right: 30px;
		display: flex;
	}

	.shangleftBox {
		width: 60px;
		height: 60px;
		background: #a3a3a3;
		border-radius: 5px;
	}

	.shangp1 {
		font-size: 14px;
		color: #666;
		margin-bottom: 4px;
	}

	.shangp2 {
		font-size: 12px;
		color: #666;

	}

	.hetonglist {
		margin-bottom: 8px;
		font-size: 14px;
		color: #666;
	}

	.prolist {
		display: flex;
		line-height: 40px;
	}

	.prolistname {
		width: 110px;
		text-align: right;
		padding-right: 12px;
		box-sizing: border-box;
	}

	.shengqx {
		display: flex;
		justify-content: center;
		align-items: center;
	}
    .table_tf tr td{
        padding: 5px 0px;
        color:black;
        font-weight: bold;
    }
    .table_tf tr td span{
        color:#222222;
        font-weight: bold;
    }
</style>


<style>
	.qizhishij .el-date-editor .el-range__close-icon {
		display: none;
		width: 0;
		height: 0;
	}

	.qizhishij .el-date-editor .el-range-input {
		width: 45%;
	}

	.qizhishij .el-range-editor.el-input__inner {
		padding: 3px 6px;
	}

	.meslist .editor.el-input,
	.meslist .el-date-editor.el-input__inner {
		width: 100px;
		min-width: 100px;
	}

	.leftbox .block .el-carousel__arrow--left {
		position: absolute;
		left: auto;
		right: 80px;
	}

	.rightBox .xiala1 .el-collapse-item__header {
		height: auto;
		line-height: normal;
		background: #ededed;
	}

	.rightBox .xiala1 .el-collapse-item__content {
		padding-bottom: 0;
	}

	.rightBox .xiala1 .el-collapse-item__wrap {
		background: #ededed;
	}

	.rightBox .xiala1 .el-collapse-item__header {
		width: 26px;
		height: 26px;
		border: 2px solid #8CBB77;
		text-align: center;
		border-radius: 15px;
		position: absolute;
		right: 25px;
		background: #fff;
		line-height: 10px;
		top: 10px
	}

	.rightBox .xiala1 .el-collapse-item__header i {
		font-size: 20px;
		float: none;
		margin-right: 0;
		color: #8CBB77;
		line-height: 26px;

	}

	.rightBox .xiala2 .el-collapse-item__wrap {
		width: 100%;
	}

	.rightBox .xiala2 .el-collapse-item__header {
		height: auto;
		line-height: normal;
		border: none;
	}

	.rightBox .xiala2 .el-collapse {
		border: none;
	}

	.rightBox .xiala2 i {

		position: absolute;
		right: 25px;
		top: 42px;
		width: 26px;
		height: 26px;
		margin-right: 0;
		line-height: 26px;

		text-align: center;
		font-size: 20px;
		color: #8CBB77;
		border: 2px solid #8CBB77;
		border-radius: 15px;
	}

	.rightBox .xiala2 .el-collapse-item__content {
		padding-bottom: 0;
	}

	.rightBox .xiala2 .el-collapse-item__wrap {
		border: none;
	}

	.convert_dialog .el-dialog__body {
		padding: 0;
	}
	.k_dialog .el-col-4 {
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.k_dialog .el-col-4::before {
		content: "*";
		color: red;
	}
    .k_dialog .el-dialog__header {
        padding: 10px!important;
    }
    .k_dialog .el-dialog__headerbtn {
        top: unset!important
    }
</style>



// WEBPACK FOOTER //
// src/pages/huiyuan/huiyuanx2.vue